<template>
  <div class="activity-summary-table">
    <portal to="context-portal">
      <v-container class="pa-0">
        <v-layout>
          <v-flex xs6>
            <v-autocomplete
              v-model="selectedActivity"
              :items="items"
              :allow-overflow="false"
              item-text="name"
              item-value="id"
              persistent-hint
              prepend-icon="search"
              label="Find activity ..."
            ></v-autocomplete>
          </v-flex>
          <v-flex xs6>
            <v-overflow-btn
              dense
              small
              single-line
              return-object
              v-model="selectedSortOption"
              :items="sortOptions"
              label="sort activities"
              item-text="title"
              item-value="title"
            ></v-overflow-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </portal>
    <v-pagination
      v-if="!isLoading"
      v-model="pagination.page"
      :length="Math.ceil(items.length / pagination.rowsPerPage)"
      class="stick-header fill-width"
    />
    <!-- <activity-summary-list :activities="items" /> -->
    <v-data-table
      ref="table"
      class="metro-table activity-table"
      v-if="!isLoading"
      :loading="isLoading"
      :pagination.sync="pagination"
      :items="items"
      :headers="headers"
      :rows-per-page-items="[10,20,50,100]"
      :hide-headers="true"
    >
    <template slot="items" slot-scope="props">
      <activity-summary-list-item :item="props.item" />
    </template>
    </v-data-table>
  </div>
</template>

<script>
import dataAccessor from '@/data-access/dataAccessor';
import loadingMixin from '@/mixins/loadingMixin';
import ActivitySummaryList from '@/ux/components/activities/ActivitySummaryList.vue';
import ActivitySummaryListItem from '@/ux/components/activities/ActivitySummaryListItem.vue';
import moment from 'moment';

export default {
  name: 'activity-main-view',
  components: { ActivitySummaryList, ActivitySummaryListItem },
  props: {
    sort: {
      type: String,
      required: false,
      default: 'start_date',
    },
    direction: {
      type: String,
      required: false,
      default: 'desc',
    },
  },
  computed: {
    pagination: {
      // tslint:disable-next-line:object-literal-shorthand
      get: function() {
        return this.$store.getters.pagination;
      },
      // tslint:disable-next-line:object-literal-shorthand
      set: function(value) {
        if (value.sortBy === undefined) {
          value.sortBy = 'start_date';
        }
        this.$store.commit('setPagination', value);
      },
    },
  },
  data: () => ({
    items: [],
    headers: [
      { text: 'Name', value: 'name' },
      { text: 'Date', value: 'start_date', align: 'right' },
      { text: 'Duration', value: 'elapsed_time', align: 'right' },
      { text: 'Elevation', value: 'total_elevation_gain', align: 'right' },
      { text: 'Distance', value: 'distance', align: 'right' },
    ],
    progress: {
      current: 0,
      total: 0,
    },
    selectedActivity: null,
    sortOptions: [
      { title: 'Most recent', sort: 'start_date', direction: 'desc' },
      { title: 'Longest distance', sort: 'distance', direction: 'desc' },
      { title: 'Longest duration', sort: 'elapsed_time', direction: 'desc' },
      { title: 'Most elevation', sort: 'total_elevation_gain', direction: 'desc' }],
    selectedSortOption: null,
    activityRouteName: 'activityBottomNav',
  }),
  mixins: [loadingMixin],
  watch: {
    sort(to, from) {
      this.propsChanged();
    },
    direction(to, from) {
      this.propsChanged();
    },
    selectedSortOption(srt) {
      if (!this.initialising) {
        if (srt) {
          this.$store.commit('setPaginationByProps', { sort: srt.sort, direction: srt.direction });
        }
      }
    },
    selectedActivity(activityId) {
      this.navigateToActivity(activityId);
    },
  },
  async mounted() {
    this.initialising = true;
    await this.sync();
    this.setCurrentSort();
    this.initialising = false;
  },
  methods: {
    propsChanged() {
      this.$store.commit('setPaginationByProps', { sort: this.sort, direction: this.direction });
    },
    onActivityClicked(activity) {
      this.navigateToActivity(activity.id);
    },
    navigateToActivity(activityId) {
      this.$router.push({ name: this.activityRouteName, params: { id: activityId } });
    },
    setCurrentSort() {
      const current = this.sortOptions.find((so) => (so.sort === this.sort) && (so.direction === this.direction));
      if (current) {
        this.selectedSortOption = current;
      }
    },
    async sync() {
      let activities = [];
      this.items = await dataAccessor.sync(
        async (c, t, act) => {
          this.progress = { current: c, total: t };
          activities = act;
          this.loadingProgress('Loading activities', c > 0 ? Math.round((c * 100) / t) : 0);
        },
        0,
      );
      this.loadingEnd();
    },
  },
};
</script>
<style lang="scss">
.activity-summary-table {
  .stick-header {
    position: fixed;
    background: white;
    z-index: 2;
  }

  .activity-table {
    table {
      margin-top: 50px !important;
    }
  }
}
</style>
